// @ts-nocheck
import {
  GET_SYSTEM_NOTIFICATIONS_FAILURE,
  GET_SYSTEM_NOTIFICATIONS_REQUEST,
  GET_SYSTEM_NOTIFICATIONS_SUCCESS,
  UPDATE_SYSTEM_NOTIFICATIONS_FAILURE,
  UPDATE_SYSTEM_NOTIFICATIONS_REQUEST,
  UPDATE_SYSTEM_NOTIFICATIONS_SUCCESS,
} from "../../constants/config/systemNotifications";

const initialState = {
  config: null,
  loading: true,
  saving: false,
  error: null,
};

const systemNotificationsReducer = (state = initialState, action) => {
  switch (action?.type) {
    case GET_SYSTEM_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case GET_SYSTEM_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action?.payload,
        error: null,
      };

    case GET_SYSTEM_NOTIFICATIONS_FAILURE:
      return { ...state, loading: false, error: action?.payload || null };

    case UPDATE_SYSTEM_NOTIFICATIONS_REQUEST:
      return { ...state, saving: true, error: null };

    case UPDATE_SYSTEM_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        saving: false,
        config: action?.payload,
        error: null,
      };

    case UPDATE_SYSTEM_NOTIFICATIONS_FAILURE:
      return { ...state, saving: false, error: action?.payload || null };

    default:
      return state;
  }
};

export default systemNotificationsReducer;
export { initialState };